import { StrictMode, startTransition } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'

import { initAnalytics } from './analytics'
import { rumInstrumentation } from './datadog-instrumentation.client'
import { initInstrumentation } from './instrumentation.client'
import { reportNavigationServerTiming } from './server-timing.client'

// First client entry for atlas-web. React Router framework mode picks this up
// automatically. Kicks off Datadog RUM + Logs init (no-op outside production for
// RUM) and wires RR's client Instrumentation API to forward navigation/fetcher
// timing to RUM.
//
// The Server-Timing report is chained onto init rather than called alongside it:
// it needs RUM to already be live, and the navigation entry it reads is complete
// long before this point (VIT-17752).
void initInstrumentation().then(reportNavigationServerTiming)

// GA4 (VIT-17882). Runs before hydration, so the initial page view it records reads the
// server-rendered <title>. No-op outside production. Subsequent page views come from
// app/use-page-view.ts, mounted in the root route.
initAnalytics()

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter instrumentations={[rumInstrumentation]} />
    </StrictMode>,
  )
})
